export default {
  menu: {
    clientMyAccount: "My account",
    clientAccount: "Company details",
    clientSettings: "System defaults",
    imapSync: "Email synchronisation",
  },
  defaultData: {
    input: {
      defaultCountry: "System country",
      defaultCurrency: "System currency",
      language: {
        label: "System language",
        text: "The language used for automatic processes, \n like generating a PDF from an invoice"
      },
    },
    error: {
      country: "Select a default country",
      currency: "Select a default currency",
    },
    success: {
      patch: "Data saved",
    },
    buttons: {
      save: "Save",
    },
  },
}
